import { Injectable } from '@angular/core';
import { Subject }    from 'rxjs/Subject';
import { APPCONFIG } from '../config'
import {ToasterContainerComponent, ToasterConfig, ToasterService, Toast} from 'angular2-toaster'

@Injectable()
export class LayoutService {

    constructor(private toasterService: ToasterService){}

    public toasterConfig : ToasterConfig = new ToasterConfig({
		timeout: APPCONFIG.toasterDefaultTimeOut,
		positionClass: APPCONFIG.toasterDefaultPositionClass
    });
    
    popToastWithTimeOut(title:string, type:string, timeout:number) {
        var toast: Toast = {type: type, body: title, timeout: timeout}; this.toasterService.pop(toast);
    }
    popToast(title:string, type:string) {
        var toast: Toast = {type: type, body: title};  this.toasterService.pop(toast);
    }

    private preloaderStateSource = new Subject<string>();
    preloaderState$ = this.preloaderStateSource.asObservable();

    updatePreloaderState(state: string) {
        // console.log('preloader state: ' + state)
        this.preloaderStateSource.next(state);
    }


    private searchOverlaySource = new Subject<string>();

    searchOverlayState$ = this.searchOverlaySource.asObservable();

    updateSearchOverlayState(state: string) {
        // console.log('overlay state: ' + state)
        this.searchOverlaySource.next(state);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/layout/layout.service.ts